import { render, staticRenderFns } from "./VouchersBalance.vue?vue&type=template&id=5444acbc&"
import script from "./VouchersBalance.vue?vue&type=script&lang=js&"
export * from "./VouchersBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5444acbc')) {
      api.createRecord('5444acbc', component.options)
    } else {
      api.reload('5444acbc', component.options)
    }
    module.hot.accept("./VouchersBalance.vue?vue&type=template&id=5444acbc&", function () {
      api.rerender('5444acbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwg/js/components/VouchersBalance.vue"
export default component.exports